(() => {
  const selects = Array.from(document.querySelectorAll('[data-bstudio-float-select]'));
  const whatsappButtons = Array.from(document.querySelectorAll('[data-contact-whatsapp-link]'));

  const update = (el) => {
    const hasValue = (el.value || '').trim() !== '';
    el.dataset.hasValue = hasValue ? 'true' : 'false';
  };

  const applyWhatsAppLink = () => {
    if (!whatsappButtons.length) return false;

    const dataNode = document.querySelector('#whatsapp-connect-data');
    if (!dataNode) return false;

    try {
      const data = JSON.parse(dataNode.textContent || '{}');
      const href = (data.linkHref || '').trim();
      if (!href) return false;

      whatsappButtons.forEach((button) => {
        button.href = href;
        button.hidden = false;
        button.removeAttribute('aria-disabled');
      });

      return true;
    } catch (error) {
      return false;
    }
  };

  selects.forEach((el) => {
    update(el);
    el.addEventListener('change', () => update(el));
    el.addEventListener('blur', () => update(el));
  });

  if (!applyWhatsAppLink() && whatsappButtons.length) {
    let attempts = 0;
    const maxAttempts = 20;
    const retryDelayMs = 500;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (applyWhatsAppLink() || attempts >= maxAttempts) {
        window.clearInterval(retry);
      }
    }, retryDelayMs);
  }

  const params = new URLSearchParams(window.location.search || '');
  const queryPrefillProperty = (params.get('contact_property') || '').trim();
  const propertyInputs = Array.from(document.querySelectorAll('[name="contact[Immobile]"]'));

  propertyInputs.forEach((input) => {
    const currentValue = (input.value || '').trim();
    if (currentValue !== '') return;

    const dataPrefillProperty = (input.dataset.contactPrefillProperty || '').trim();
    const prefillProperty = queryPrefillProperty || dataPrefillProperty;
    if (!prefillProperty) return;

    input.value = prefillProperty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

